import { PageLayout } from '~/components/PageLayout/PageLayout';
import { CompetitionForm } from './components/competition-form';
import { useCreateCompetitionMutation } from '../mutations';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { Schema } from './schema';
import { Fragment } from 'react';

export const Page = withPrivateRoute(() => {
  const mutation = useCreateCompetitionMutation();

  async function handleSubmit(payload: Schema) {
    return await mutation.mutateAsync(payload);
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Skapa tävling" />

      <PageLayout.Section>
        <CompetitionForm onSubmit={handleSubmit} isPending={mutation.isPending} />
      </PageLayout.Section>
    </Fragment>
  );
});
